module.exports = __webpack_public_path__ + "img/Twitter_footer.d9bcfc6f.svg";